var _circle, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYuan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#00C2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7L13 3",
    stroke: "#00C2FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYuan);
export default __webpack_public_path__ + "static/media/yuan.3dc029b0f672514ec8114f6ff7245667.svg";
export { ForwardRef as ReactComponent };